import React from "react";
import { motion } from "framer-motion";
import { buildWhatsAppLink, WHATSAPP_MESSAGES } from "../lib/site";

// Reusable WhatsApp CTA. variant: "primary" | "secondary"
export const WhatsAppCTA = ({
  message = WHATSAPP_MESSAGES.main,
  label = "Falar no WhatsApp",
  variant = "primary",
  pulse = false,
  fullWidth = false,
  icon = null,
  testId = "whatsapp-cta",
  className = "",
}) => {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-full px-8 py-4 text-[15px] font-medium tracking-tight transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/30";
  const variants = {
    primary: "bg-[#f5f5f7] text-[#050505] hover:bg-white",
    secondary:
      "bg-transparent border border-white/15 text-[#f5f5f7] hover:bg-white/5 hover:border-white/30",
  };

  return (
    <motion.a
      href={buildWhatsAppLink(message)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      whileHover={{ scale: 1.03 }}
      whileTap={{ scale: 0.97 }}
      className={`${base} ${variants[variant]} ${fullWidth ? "w-full" : ""} ${
        pulse ? "cta-pulse" : ""
      } ${className}`}
    >
      {icon}
      {label}
    </motion.a>
  );
};
